<template>
    <div>
        <!-- 关联服务 -->
        <el-table :data="detail.toService">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>